'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleErrorObject = require('simple-error-object');

var _simpleErrorObject2 = _interopRequireDefault(_simpleErrorObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Check and Return Error Object.
 * Error Object is Using simple-error-object.
 * https://github.com/WireframesJPN/simple-error-object
 * {
 *  user_id: 'required|email', // add validator with pipe,
 *  password: [ 'required', 'not_in:test,aaaa', 'regex:^[0-9a-zA-Z]+$' ] // or array.
 * }
 */
var SimpleValid = function () {
  function SimpleValid(rules, messages) {
    _classCallCheck(this, SimpleValid);

    this.rules = {};
    this.prepares = {};
    this.messages = {};
    this.addRules(rules, messages);
    this.values = {};
  }

  /**
   * Add Rule
   * @param name
   * @param rule
   * @param message
   */


  _createClass(SimpleValid, [{
    key: 'addRule',
    value: function addRule(name, rule, message) {
      if (typeof rule !== 'function' && rule.length) {
        if (typeof rule[0] === 'function') this.rules[name] = rule[0];
        if (typeof rule[1] === 'function') this.prepares[name] = rule[1];
      } else {
        if (typeof rule === 'function') this.rules[name] = rule;
      }
      if (message) {
        this.messages[name] = message;
      }
    }

    /**
     * Add Rules
     * @param rules
     * @param messages
     */

  }, {
    key: 'addRules',
    value: function addRules(rules, messages) {
      for (var key in rules) {
        if (messages[key] === undefined) {
          messages[key] = key + ' was undefined';
        }
        this.addRule(key, rules[key], messages[key]);
      }
    }
  }, {
    key: 'setValues',
    value: function setValues(values) {
      this.values = values;
    }
  }, {
    key: 'setRules',
    value: function setRules(target) {
      /**
       * // Create Rules Object Like this..
       * {
       *  'email': [
       *    { name: 'required', params: null },
       *    { name: 'email', params: null },
       *  ]
       * }
       */
      var result = {};
      for (var key in target) {
        var rules = target[key];
        var ruleStrings;
        /**
         *
         */
        if (typeof rules != 'string' && rules.length !== undefined) {
          ruleStrings = rules;
        } else {
          ruleStrings = rules.split('|');
        }
        result[key] = [];
        for (var i = 0; i < ruleStrings.length; i++) {
          result[key].push(this.createRuleObject(ruleStrings[i], key));
        }
      }

      this.check_rules = result;
    }

    /**
     * execute validation.
     * @param {object} values
     * @param {object} rules
     * @param {object} messages
     * @returns {*}
     */

  }, {
    key: 'execute',
    value: function execute(values, rules) {
      var messages = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};


      this.setValues(values);
      this.setRules(rules);
      var errors = new _simpleErrorObject2.default();

      try {
        for (var target in this.check_rules) {
          var target_val = this.values[target] === undefined ? false : this.values[target];
          if (target_val === false) throw 'Missing Validation Target.';
          var error = this.check(this.check_rules[target], target_val);
          if (error) {
            var message = this.getMessage(error.name, target, messages);
            errors.add(target, typeof message === 'function' ? message(error.value, error.rule.params) : message);
          }
        }
        return errors;
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: 'createRuleObject',
    value: function createRuleObject(ruleString, key) {
      /**
       * // Create Validation Rule Object Like this..
       * {
       *  name: '',
       *  params: []
       * }
       */
      var rule = ruleString.split(':');
      var name = rule[0];

      // Preparing Rule Object.
      /**
       * you can modify rule object if you set up the preparing object.
       */
      if (this.prepares[name] !== undefined) {
        rule = this.prepares[name](this.values, key, rule);
      }

      var params = void 0;
      if (rule[1] !== undefined) {
        params = rule[1].split(',');
      }

      return {
        name: name,
        params: params ? params : null
      };
    }
  }, {
    key: 'check',
    value: function check(rules, value) {
      for (var i = 0; i < rules.length; i++) {
        var result = this.checkRule(value, rules[i]);
        if (result) {
          return result;
        }
      }
      return false;
    }

    /**
     * check validation rules and add error if exist.
     * error
     * @param value
     * @param rule
     * @return {string|boolean}
     */

  }, {
    key: 'checkRule',
    value: function checkRule(value, rule) {
      var name = rule.name;
      var params = rule.params;
      if (this.rules[name] === undefined) return 'norule';
      return this.rules[name](value, params) ? { name: name, value: value, rule: rule } : false;
    }
  }, {
    key: 'getMessage',
    value: function getMessage(name, target, message) {
      var _message = void 0;
      if (message && message[target] !== undefined && message[target][name] !== undefined) {
        _message = message[target][name];
      } else {
        _message = this.messages[name];
      }
      return _message;
    }
  }]);

  return SimpleValid;
}();

exports.default = SimpleValid;